<template>
	<div>
		<div class="row">
			<div class="col-lg-12">
				<label for="">Estatus</label>
				<select v-model="ObjEnviar.EstatusDistribuidor" class="form-control">
					<option value="">-Estatus-</option>
					<option value="solicitado">Solicitado</option>
					<option value="bajo pedido">Bajo Pedido</option>
					<option value="entregado">Entregado</option>
				</select>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:'clientes',
	props:["poBtnSave"],
	data() {
		return {
			Modal:true,
			FormName:'solicitud',
			EmitSeccion:this.poBtnSave.EmitSeccion,
			ObjEnviar:{
				Id:0,
				IdDistribuidor:0,
				Tipo:'',
				IdCotizacionServicio:0,
				EstatusDistribuidor:''
			}
		}
	},
	methods: {
		async Guardar(){
			this.poBtnSave.toast = 0;
			this.poBtnSave.disableBtn=true;
			let formData=new FormData();
			formData.set('Id',this.ObjEnviar.Id);
			formData.set('IdDistribuidor',this.ObjEnviar.IdDistribuidor);
			formData.set('Tipo',this.ObjEnviar.Tipo);
			formData.set('IdCotizacionServicio',this.ObjEnviar.IdCotizacionServicio);
			formData.set('EstatusDistribuidor',this.ObjEnviar.EstatusDistribuidor);
			await this.$http.post('sucursalxdistribuidor/updateestatus',formData).then((res)=>{
				this.poBtnSave.disableBtn = false;
				this.poBtnSave.toast = 1;
				this.bus.$emit('List_'+this.EmitSeccion);
				$('#Solicitud').modal('hide');
			});
		},
		// async Recuperar(){

		// }
		Limpiar(){
			this.ObjEnviar={
				Id:0,
				IdDistribuidor:0,
				Tipo:'',
				IdCotizacionServicio:0,
				EstatusDistribuidor:''
			};
		}
	},
	mounted() {
		this.bus.$off('NewModal_'+this.EmitSeccion);
		this.bus.$on('NewModal_'+this.EmitSeccion,(Id,IdDistribuidor,Tipo,IdCotizacionServicio,EstatusDistribuidor)=>{
			this.Limpiar();
			this.ObjEnviar.Id=Id;
			this.ObjEnviar.IdDistribuidor=IdDistribuidor;
			this.ObjEnviar.Tipo=Tipo;
			this.ObjEnviar.IdCotizacionServicio=IdCotizacionServicio;
			this.ObjEnviar.EstatusDistribuidor=EstatusDistribuidor;
			console.log(this.ObjEnviar);
			// this.Recuperar();
			this.bus.$off('Save_'+this.EmitSeccion);
			this.bus.$on('Save_'+this.EmitSeccion,()=>{
				this.Guardar();
			});
		});
	},
}
</script>

<style>

</style>
